<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
	import { Modal } from "bootstrap";
	export default {
		components: {},
		data: function () {
			return {
				modal: null,
			};
		},
		watch: {},
		created() {},
		computed: {},
		methods: {
			create: function (id, options) {
				this.modal = new Modal(document.getElementById(id), options);
			},
			show: function () {
				if (!this.modal) return;

				this.modal.show();
			},
			toggle: function () {
				if (!this.modal) return;

				this.modal.toggle();
			},
			hide: function () {
				if (!this.modal) return;

				this.modal.hide();
			},
			dispose: function () {
				if (!this.modal) return;

				this.modal.dispose();
			},
		},
		mounted() {},
	};
</script>
